import * as React from "react"

const ListItem = ({ className, children }) => {
  return (
    <li
      className={`flex flex-row items-start gap-4 pb-1 last:pb-0 ${
        className ? className : ""
      }`}
    >
      <div className={"w-4 pt-1"}>
        <svg
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          className={"w-4 h-4 text-blue fill-current"}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
          ></path>
        </svg>
      </div>

      <div>{children}</div>
    </li>
  )
}

export default ListItem
